module.exports = __webpack_public_path__ + "static/media/like-fill.35c1b19e.svg";